var _a;
export var AccountTypeLabel;
(function (AccountTypeLabel) {
    AccountTypeLabel["INTEREST_CHECKING"] = "INTEREST CHECKING";
    AccountTypeLabel["SAVINGS"] = "SAVINGS";
    AccountTypeLabel["CDs"] = "CDs";
    AccountTypeLabel["ROBO_PORTFOLIO"] = "ROBO PORTFOLIO";
    AccountTypeLabel["SELF_DIRECTED"] = "SELF-DIRECTED";
    AccountTypeLabel["WEALTH_MANAGEMENT"] = "WEALTH MANAGEMENT";
})(AccountTypeLabel || (AccountTypeLabel = {}));
export var AccountType;
(function (AccountType) {
    AccountType["DDA"] = "DDA";
    AccountType["MMA"] = "MMA";
    AccountType["SDA"] = "SDA";
    AccountType["CMG"] = "CMG";
    AccountType["CDA"] = "CDA";
    AccountType["INVS"] = "INVS";
    AccountType["INVA"] = "INVA";
    AccountType["INVW"] = "INVW";
})(AccountType || (AccountType = {}));
export var AccountTypeToLabel = (_a = {},
    _a[AccountType.DDA] = AccountTypeLabel.INTEREST_CHECKING,
    _a[AccountType.MMA] = AccountTypeLabel.SAVINGS,
    _a[AccountType.SDA] = AccountTypeLabel.SAVINGS,
    _a[AccountType.CMG] = AccountTypeLabel.SAVINGS,
    _a[AccountType.CDA] = AccountTypeLabel.CDs,
    _a[AccountType.INVS] = AccountTypeLabel.SELF_DIRECTED,
    _a[AccountType.INVA] = AccountTypeLabel.ROBO_PORTFOLIO,
    _a[AccountType.INVW] = AccountTypeLabel.WEALTH_MANAGEMENT,
    _a);
//# sourceMappingURL=selectorTypes.js.map